// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".TimelineViewMenuPopover-content__TzcgU{display:flex;flex-direction:column;align-items:flex-start;align-self:stretch;padding:var(--size-3)}.TimelineViewMenuPopover-item__rH0gF{min-height:0;min-height:initial;padding:var(--size-1_5) var(--size-1) var(--size-1_5) 0}.TimelineViewMenuPopover-itemLabel__QEJyc{font:var(--font-body-400-compact);font-feature-settings:var(--feature-settings-body-400-compact);letter-spacing:var(--letter-spacing-body-400-compact)}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"content": "TimelineViewMenuPopover-content__TzcgU",
	"item": "TimelineViewMenuPopover-item__rH0gF",
	"itemLabel": "TimelineViewMenuPopover-itemLabel__QEJyc"
};
export default ___CSS_LOADER_EXPORT___;
